import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Observable, BehaviorSubject, EMPTY, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { LabelType } from "ng5-slider";
import { AuthService } from "./auth.service";
import { TenantService } from "./tenant.service";

@Injectable({
  providedIn: "root",
})
export class HomepageService {
  tetent: string = "";
  tenantLocId: any = "";
  confiGurationSetting: string = "*";
  recentSearch: string = "";
  private bannerText: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  public bannerText$: Observable<any[]> = this.bannerText.asObservable();
  private theme: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  public theme$: Observable<any[]> = this.theme.asObservable();

  private dataSource: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  public currentData: Observable<any[]> = this.dataSource.asObservable();
  unsubscribeResponse: Response;

  private isLogin: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  public isLogin$: Observable<any[]> = this.isLogin.asObservable();

  private isCardRoute: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  public isCardRoute$: Observable<any[]> = this.isCardRoute.asObservable();

  constructor(
    private http: HttpClient,
    private router: Router,
    private cookieService: CookieService,
    private authService: AuthService,
    private tenantService: TenantService
  ) {
    this.tetent = this.tenantService.tenant;
    this.confiGurationSetting = this.tenantService.configurationSetting;
    // Restore the last-known location from the session cookie so that the
    // first API calls (getConfig, setRegionalSettings) don't fire with an
    // empty selectedlibrary header, which the backend may resolve to a
    // location that doesn't belong to this tenant.
    const savedLoc = this.cookieService.get('selectedlocation' + this.tetent);
    if (savedLoc) {
      this.tenantLocId = savedLoc;
    }
  }

  private readonly apiUrl = environment.apiUrl;
  gloalSettingAPI: any;
  globalRegionalSetting: any;
  getwidgetsSettingDataCall: boolean = false;
  getwidgetsSettingData: any;

  /* Updates the banner Text according to the  page*/
  updateBannerText(text) {
    this.bannerText.next(text);
  }

  // Update inner banner
  updateThemeName(text) {
    this.theme.next(text);
  }
  // Update location
  updateLocation_(data: any) {
    this.dataSource.next(data);
    console.log(data, "call updateloc");
  }

  updateIsLogin(text) {
    this.isLogin.next(text);
  }

  updateIsCardRoute(text) {
    this.isCardRoute.next(text);
  }

  /* Call the setting API once and store data into temprary variable */
  getConfig(): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    //if (localStorage.getItem('info') != null){
    var auth: any = "Bearer " + localStorage.getItem("token");
    //}
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
 
    return this.http.get(this.apiUrl + "setting", { headers: headers, observe:'response' }).pipe(
      // catchError(this.handleError),
      map((response: HttpResponse<any>) => {
        this.gloalSettingAPI = response.body;
        this.setListView(response.body);
        this.authService.setIdleTimer();
        if(response.headers.get('Session-Id')){
         this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
        }
        return response.body;
      }),
      catchError((error) => this.handleError(error))
    );
  }

  getLocationConfig(locationId: string): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: locationId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
 
    return this.http
      .get(this.apiUrl + "setting/configforlocation/" + locationId, { headers: headers, observe:'response' })
      .pipe(
        // catchError(this.handleError),
        map((response:  HttpResponse<any>) => {
          this.gloalSettingAPI = response.body;
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  setRegionalSettings(): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
 
    return this.http
      .get(this.apiUrl + "setting/regionalsettings", { headers: headers, observe:'response' })
      .pipe(
        // catchError(this.handleError),
        map((response: HttpResponse<any>) => {
          this.globalRegionalSetting = response.body;
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  /* Get the library setting data from temprary varible to avoid the calls on  diffrent pages */
  getUpdatedConfig() {
    return this.gloalSettingAPI;
  }

  getUpdatedRegionalSettings() {
    return this.gloalSettingAPI;
  }

  //save default list view type
  setListView(data) {
    var temp;
    if (data.data.settings.resultList.defaultView == "compact list") {
      temp = "compact";
    } else if (data.data.settings.resultList.defaultView == "list") {
      temp = "true";
    } else if (data.data.settings.resultList.defaultView == "grid") {
      temp = "false";
    }
    this.cookieService.set("Popular_title_List_View", temp, 365, "/");
  }

  /* CAll to widgets setting with data for home page and store into temrary variable */
  getwidgetsSetting(): Observable<any> {
    if (this.getwidgetsSettingDataCall === false) {
      var auth: any = "null";
      //if(this.cookieService.check( 'info')){
      if (localStorage.getItem("info") != null) {
        var auth: any = "Bearer " + localStorage.getItem("token");
      }
   
      let headers = new HttpHeaders({
        "app-id": "opac",
        selectedlibrary: this.tenantLocId,
        tenant: this.tetent,
        configuration: this.confiGurationSetting,
        Authorization: auth,
      });
      return this.http
        .get(this.apiUrl + "widget/settingswithcontent", { headers: headers, observe:'response' })
        .pipe(
          map((response: HttpResponse<any>) => {
            this.getwidgetsSettingData = response.body;
            this.getwidgetsSettingDataCall = true;
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
    } else {
      this.getwidgetsSettingDataSave();
    }
  }

  /* getupdated */
  getwidgetsupdatedSetting(): Observable<any> {
 
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(this.apiUrl + "widget/settingswithcontent", { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          this.getwidgetsSettingData = response.body;
          this.getwidgetsSettingDataCall = true;
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }
  /* getupdated */

  checkContentHave() {
    return this.getwidgetsSettingDataCall;
  }

  /* Get the library widget setting data from temprary varible to avoid the calls on  diffrent pages */
  getwidgetsSettingDataSave() {
    return this.getwidgetsSettingData;
  }

  /* getting the data for the popular title page */
  getPopularPage(sortBy, descending, listSize, facets, exploreId?): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    if(exploreId){
      exploreId = "&exp-btn-id=" +
          exploreId
    }else{
      exploreId = ''
    }
    return this.http
      .get(
        this.apiUrl +
          "resource/list/popular?size=" +
          listSize +
          "&offset=0&order=" +
          sortBy +
          "&descending=" +
          descending +
          "&facets=" +
          facets +
          exploreId,
          { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  /* getting the data for the recommended-for-you list page (same shape as popular) */
  getRecommendedPage(sortBy, descending, listSize, facets, exploreId?): Observable<any> {
    var auth: any = "null";
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    if(exploreId){
      exploreId = "&exp-btn-id=" +
          exploreId
    }else{
      exploreId = ''
    }
    return this.http
      .get(
        this.apiUrl +
          "resource/list/recommended?size=" +
          listSize +
          "&offset=0&order=" +
          sortBy +
          "&descending=" +
          descending +
          "&facets=" +
          facets +
          exploreId,
          { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  /* getting the data for the Resouce lists page */
  getReadinlist(exploreId?): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    if(exploreId){
      exploreId = "?exp-btn-id=" +
          exploreId
    }else{
      exploreId = ''
    }
    return this.http.get(this.apiUrl + "resource/list"+exploreId, { headers: headers, observe:'response' }).pipe(
      map((response: HttpResponse<any>) => {
        if(response.headers.get('Session-Id')){
         this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
        return response.body;
      }),
      catchError((error) => this.handleError(error))
    );
  }

  /* getting the recommended-for-you widget content (loaded asynchronously) */
  getRecommended(size, offset = 0): Observable<any> {
    var auth: any = "null";
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(
        this.apiUrl +
          "widget/recommended?size=" +
          size +
          "&offset=" +
          offset,
          { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  /* getting the data for the new in library page */
  getNewInLibararyPage(sortBy, descending, size, facets): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(
        this.apiUrl +
          "resource/list/new?size=" +
          size +
          "&offset=0&order=" +
          sortBy +
          "&descending=" +
          descending +
          "&facets=" +
          facets,
          { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  /* call the api to sorted data from result list pages*/
  getSortPageByCache(
    sortBy,
    descending,
    cache,
    size,
    offset,
    facets,
    exploreId?
  ): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    if(exploreId){
      exploreId = "&exp-btn-id=" +
          exploreId
    }else{
      exploreId = ''
    }
    return this.http
      .get(
        this.apiUrl +
          "resource/list/page?cacheKey=" +
          cache +
          "&size=" +
          size +
          "&offset=" +
          offset +
          "&order=" +
          sortBy +
          "&descending=" +
          descending +
          "&facets=" +
          facets + exploreId,
        
          { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          this.setLastSearch(
            "resource/list/page?cacheKey=" +
              cache +
              "&size=" +
              size +
              "&offset=" +
              offset +
              "&order=" +
              sortBy +
              "&descending=" +
              descending + exploreId,
          );
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  /* Get norrow result from search result*/
  searchNorrowResult(
    sortBy,
    descending,
    cache,
    size,
    offset,
    facets,
    exploreId?,
  ): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    if(exploreId){
      exploreId = "&exp-btn-id=" +
          exploreId
    }else{
      exploreId = ''
    }
    return this.http
      .get(
        this.apiUrl +
          "resource/list/page?cacheKey=" +
          cache +
          "&size=" +
          size +
          "&offset=" +
          offset +
          "&order=" +
          sortBy +
          "&descending=" +
          descending +
          "&facets=" +
          facets + exploreId,
          { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          this.setLastSearch(
            "resource/list/page?cacheKey=" +
              cache +
              "&size=" +
              size +
              "&offset=" +
              offset +
              "&order=" +
              sortBy +
              "&descending=" +
              descending + exploreId,
          );
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  /* Get norrow result from new result*/
  newNorrowResult(
    sortBy,
    descending,
    cache,
    size,
    offset,
    facets
  ): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(
        this.apiUrl +
          "resource/list/new?cacheKey=" +
          cache +
          "&size=" +
          size +
          "&offset=" +
          offset +
          "&order=" +
          sortBy +
          "&descending=" +
          descending +
          "&facets=" +
          facets,
          { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          this.setLastSearch(
            "resource/list/new?cacheKey=" +
              cache +
              "&size=" +
              size +
              "&offset=" +
              offset +
              "&order=" +
              sortBy +
              "&descending=" +
              descending +
              "&facets=" +
              facets
          );
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  /* Get norrow result from popular result*/
  popularNorrowResult(
    sortBy,
    descending,
    cache,
    size,
    offset,
    facets
  ): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(
        this.apiUrl +
          "resource/list/popular?cacheKey=" +
          cache +
          "&size=" +
          size +
          "&offset=" +
          offset +
          "&order=" +
          sortBy +
          "&descending=" +
          descending +
          "&facets=" +
          facets,
          { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  /* Get data for awards page */
  getAwards(): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http.get(this.apiUrl + "award/menu", { headers: headers, observe:'response' }).pipe(
      map((response: HttpResponse<any>) => {
        if(response.headers.get('Session-Id')){
         this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
        return response.body;
      }),
      catchError((error) => this.handleError(error))
    );
  }

  /* Get data of events on moving calender next/previous*/
  getEvents(yr, mnt): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(this.apiUrl + "widget/calendar?year=" + yr + "&month=" + mnt, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  /* get Resource detail data according to listID*/
  getMainResourceDetail(
    cacheKey,
    listId,
    order,
    desc,
    eagerLoad,
    facets,
    auth
  ) {
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .get(
        this.apiUrl +
          "resource/list/item?cacheKey=" +
          cacheKey +
          "&listItemId=" +
          listId +
          "&order=" +
          order +
          "&descending=" +
          desc +
          "&eagerLoad=" +
          eagerLoad +
          "&facets=" +
          facets,
          { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  /* get Resource list data according to listID*/
  getReviewResourceDetail(cacheKey, listId, catId, order, desc, eagerLoad) {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(
        this.apiUrl +
          "resource/list/" +
          listId +
          "?cacheKey=" +
          cacheKey +
          "&listItemId=" +
          listId +
          "&order=" +
          order +
          "&descending=" +
          desc +
          "&eagerLoad=" +
          eagerLoad,
          { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }
  /* function to fetch the data for detail page sections which have API end points in response */
  dynamicLoadAPI(url) {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http.get(this.apiUrl + url.replace(/^\//, ''), { headers: headers, observe:'response' }).pipe(
      map((response: HttpResponse<any>) => {
        if(response.headers.get('Session-Id')){
         this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
        return response.body;
      }),
      catchError((error) => this.handleError(error))
    );
  }

  /* Get the data for shelf on detail page*/
  getResourceShelf(resourceId, categoryId, call) {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(
        this.apiUrl +
          "resource/shelf/" +
          resourceId +
          "?categoryId=" +
          categoryId +
          "&call=" +
          call,
          { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  /* get data for the resource by th resource ID*/
  getResourceDetailById(resourceId) {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(this.apiUrl + "resource/" + resourceId, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  /* Fetch the data for availbales resources on detail page */
  getAvailableDetail(resourceId, category, callType) {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(
        this.apiUrl +
          "resource/available/" +
          resourceId +
          "?categoryId=" +
          category +
          "&call=" +
          callType,
          { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  /* get the data for explore page, Zero for the home page*/
  getExploreData(pageId: any, exploreId?: any) {
    var auth: any = "null";
    var hidden: boolean = false;
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
      var hidden: boolean = true;
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    if(exploreId){
    
      exploreId = "&exp-btn-id=" +
          exploreId
    }else{
      exploreId = ''
    }
    return this.http
      .get(this.apiUrl + "explore/page/" + pageId + "?hidden=" + hidden + exploreId,{ headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getClickExploreBtn(exploreId?: any) {
    var auth: any = "null";
    var hidden: boolean = false;
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
      var hidden: boolean = true;
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    if(exploreId){
      exploreId = "exp-btn-id=" +
          exploreId
    }else{
      exploreId = ''
    }
    return this.http
      .get(this.apiUrl + "explore/click?" + exploreId,{ headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  /* get the bullets list page*/
  getBulletinsList() {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(this.apiUrl + "bulletin/list?offset=0&size=9999",{ headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  myList(auth, sortBy, descending, size, offset, exploreId): Observable<any> {
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    if(exploreId){
      exploreId = "&exp-btn-id=" +
          exploreId
    }else{
      exploreId = ''
    }
    return this.http
      .get(
        this.apiUrl +
          "resource/list/personal?offset=0&size=" +
          size +
          "&order=" +
          sortBy +
          "&descending=" +
          descending + exploreId,
          { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  myListTemp(token, sortBy, descending, size, offset, exploreId?): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    if(exploreId){
      exploreId = "&exp-btn-id=" +
          exploreId
    }else{
      exploreId = ''
    }
    return this.http
      .get(
        this.apiUrl +
          "resource/list/page?size=" +
          size +
          "&cacheKey=" +
          token +
          "&offset=0&order=" +
          sortBy +
          "&descending=" +
          descending + exploreId,
          { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getUnsubscribeEmail(unsubscribeEmail) {
    var auth: any = "null";
    //if(this.cookieService.check('info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer" + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(this.apiUrl + "unsubscribe?u=" + unsubscribeEmail, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getLibraryCard() {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    // if (localStorage.getItem('info') != null){
    var auth: any = "Bearer " + localStorage.getItem("token");
    //}
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "Access-Control-Allow-Origin",
      Authorization: auth,
    });
    //  console.log(headers);
    return this.http.get(this.apiUrl + "profile/librarycard", { headers: headers, observe:'response' }).pipe(
      map((response: HttpResponse<any>) => {
        if(response.headers.get('Session-Id')){
         this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
        return response.body;
      }),
      catchError((error) => {return throwError(error);})
    );
  }

  awardsList(
    awardYear,
    awardId,
    lowYear,
    highYear,
    size,
    order
  ): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(
        this.apiUrl +
          "search/awards-honors?year=" +
          awardYear +
          "&award=" +
          awardId +
          "&low=" +
          lowYear +
          "&high=" +
          highYear +
          "&size=" +
          size +
          "&order=" +
          order +
          "&descending=true",
          { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  /* set the selected location id from header dropdown*/
  setLocationId(location) {
    this.tenantLocId = location.toString();
  }

  /* get the selected location id*/
  getLocationId() {
    return this.tenantLocId;
  }

  saveMyList(auth, selectedResourcesIds) {
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth,
    });

    return this.http
      .post(
        this.apiUrl + "resource/collectionitem/addtopersonal",
        { name: "My List", resourceIds: selectedResourcesIds },
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  removeMyList(auth, selectedResourcesIds) {
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth,
    });

    return this.http
      .post(
        this.apiUrl + "resource/collectionitem/removefrompersonal",
        { resourceId: selectedResourcesIds },
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  setLastSearch(url) {
    this.recentSearch = url;
  }

  getLastSearch() {
    return this.recentSearch;
  }

  reOrderWidgets(wid, newIndex, auth) {
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .post(
        this.apiUrl + "widget/settings/move/" + wid + "?position=" + newIndex,
        {},
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  clearListLogin(auth) {
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      "Content-Type": "application/json",
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .post(
        this.apiUrl + "resource/collectionitem/clearpersonalcollection",
        {},
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  clearListTemp(cacheKey) {
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      "Content-Type": "application/json",
      configuration: this.confiGurationSetting,
    });
    return this.http
      .post(
        this.apiUrl +
          "resource/collectionitem/cleartemppersonalcollection?cachekey=" +
          cacheKey,
        {},
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  autoCompleteSuggestion(searchKeyWord, searchin): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      locationId: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(
        this.apiUrl +
          "resource/suggestion?searchby=" +
          searchin +
          "&term=" +
          searchKeyWord,
          { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getNewsBulletin(maxsize): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      locationId: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(this.apiUrl + "bulletin?size=" + maxsize, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getNewsReviews(maxsize): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      locationId: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(this.apiUrl + "review/recent?size=" + maxsize, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }
  getNewsEvents(year, month): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      locationId: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(this.apiUrl + "calendar?year=" + year + "&month=" + month, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getBulletinDetail(id): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      locationId: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http.get(this.apiUrl + "bulletin/" + id, { headers: headers, observe:'response' }).pipe(
      map((response: HttpResponse<any>) => {
        if(response.headers.get('Session-Id')){
         this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
        return response.body;
      }),
      catchError((error) => this.handleError(error))
    );
  }

  getConfigList(): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(this.apiUrl + "setting/config/all/",{ headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  updateShareLinks(auth, fb, twr, pint, insta) {
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      "Content-Type": "application/json",
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .post(
        this.apiUrl + "setting/footer/socialmedia",
        { facebook: fb, twitter: twr, instagram: pint, pinterest: insta },
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }
  updateFooterLinks(auth, links) {
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      "Content-Type": "application/json",
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .post(this.apiUrl + "setting/footer/links", links, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  updateFooterContact(auth, phone, email, website) {
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      "Content-Type": "application/json",
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .post(
        this.apiUrl + "setting/footer/contact",
        { email: email, phone: phone, web: website },
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }
  personalcollection(Ids, cacheKey) {
    var auth: any = "null";
    //if (this.cookieService.check('info')) {
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
      let headers = new HttpHeaders({
        "app-id": "opac",
        selectedlibrary: this.tenantLocId,
        tenant: this.tetent,
        configuration: this.confiGurationSetting,
        "Content-Type": "application/json",
        Authorization: auth,
      });

      return this.http
        .post(
          this.apiUrl + "resource/collectionitem/addtopersonal",
          { name: "My List", resourceIds: Ids },
          { headers: headers, observe:'response' }
        )
        .pipe(
          map((response: HttpResponse<any>) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
    } else {
      var auth: any = "null";
      //if (this.cookieService.check('info')) {
      if (localStorage.getItem("info") != null) {
        var auth: any = "Bearer " + localStorage.getItem("token");
      }
      let headers = new HttpHeaders({
        selectedlibrary: this.tenantLocId,
        tenant: this.tetent,
        "Content-Type": "application/json",
        configuration: this.confiGurationSetting,
        Authorization: auth,
      });
      return this.http
        .post(
          this.apiUrl + "resource/collectionitem/addtotemppersonalcollection",
          { resourceIds: Ids, cacheKey: cacheKey },
          { headers: headers, observe:'response' }
        )
        .pipe(
          map((response: any) => {
            if(response.headers.get('Session-Id')){
              this.authService.setSessionIdHeader(response.headers.get('Session-Id'))
            }
            return response.body;
          }),
          catchError((error) => this.handleError(error))
        );
    }
  }

  removePersonalcollection(Id, cacheKey) {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      "Content-Type": "application/json",
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .post(
        this.apiUrl +
          "resource/collectionitem/removefromtemppersonalcollection",
        { resourceIds: [Id], cacheKey: cacheKey },
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  //Rearrange bulletins
  rearrangeBulletin(orderArray, auth) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      "Content-Type": "application/json",
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .post(this.apiUrl + "bulletin/rearrange", orderArray, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  saveBulletin(bHeadline, bcontent, bLocation, bDate, auth) {
    let headers = new HttpHeaders({
      tenant: this.tetent,
      "Content-Type": "application/json",
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .post(
        this.apiUrl + "bulletin/add",
        {
          locationId: bLocation,
          date: bDate,
          caption: bHeadline,
          content: bcontent,
        },
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getBulletDelete(id, auth) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .delete(this.apiUrl + "bulletin/delete/" + id, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  editBulletin(id, bHeadline, bcontent, bLocation, bDate, auth) {
    let headers = new HttpHeaders({
      tenant: this.tetent,
      "Content-Type": "application/json",
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .post(
        this.apiUrl + "bulletin/edit",
        {
          id: id,
          locationId: bLocation,
          date: bDate,
          caption: bHeadline,
          content: bcontent,
        },
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  editResourseList(id, title, content, image, allLoations, published, auth) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      "Content-Type": "application/json",
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .post(
        this.apiUrl + "resource/readinglist/update",
        {
          id: id,
          name: title,
          description: content,
          AllLocations: allLoations,
          imageUrl: image,
          published: published,
        },
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  readingListImageUpload(formData, auth) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .post(this.apiUrl + "resource/readinglist/image", formData, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  exploreImageUpload(formData, auth) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .post(this.apiUrl + "explore/button/image/upload", formData, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  unpublishReadingList(id, auth) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .post(this.apiUrl + "resource/readinglist/unpublish/" + id, [], { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  deleteReadingList(id, auth) {
    let headers = new HttpHeaders({
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .delete(this.apiUrl + "resource/readinglist/delete/" + id, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getReviewDetail(id): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      "app-id": "opac",
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http.get(this.apiUrl + "review/detail/" + id, { headers: headers, observe:'response' }).pipe(
      map((response: HttpResponse<any>) => {
        if(response.headers.get('Session-Id')){
         this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
        return response.body;
      }),
      catchError((error) => this.handleError(error))
    );
  }

  getReviewCategories(): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      "app-id": "opac",
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http.get(this.apiUrl + "review/categories", { headers: headers, observe:'response' }).pipe(
      map((response: HttpResponse<any>) => {
        if(response.headers.get('Session-Id')){
         this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
        return response.body;
      }),
      catchError((error) => this.handleError(error))
    );
  }

  addReview(
    resourceId,
    patronId,
    title,
    author,
    ratingStar,
    reviewText,
    reviewer,
    categories,
    auth
  ) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    if (auth == null) {
      let headers = new HttpHeaders({
        selectedlibrary: this.tenantLocId,
        tenant: this.tetent,
        configuration: this.confiGurationSetting,
      });
    }

    return this.http
      .post(
        this.apiUrl + "review/add",
        {
          resourceId: resourceId,
          patronId: patronId,
          title: title,
          author: author,
          ratingStar: ratingStar,
          reviewText: reviewText,
          reviewer: reviewer,
          categories: categories,
        },
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }
  editReview(
    Id,
    ratingStar,
    reviewText,
    reviewPublished,
    reviewer,
    categories,
    auth
  ) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .post(
        this.apiUrl + "review/edit",
        {
          id: Id,
          reviewer: reviewer,
          ratingStar: ratingStar,
          reviewText: reviewText,
          categories: categories,
          published: reviewPublished,
        },
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  deleteReview(id, auth) {
    let headers = new HttpHeaders({
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
      "Content-Type": "application/json",
      selectedlibrary: this.tenantLocId,
    });
    return this.http
      .delete(this.apiUrl + "review/delete/" + id, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getPublishedReadingLists(auth): Observable<any> {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      "app-id": "opac",
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth,
    });
    return this.http
      .get(this.apiUrl + "resource/publishedreadinglists", { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getReadingListsDetail(id, auth): Observable<any> {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      "app-id": "opac",
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth,
    });
    return this.http
      .get(this.apiUrl + "resource/readinglist/detail/" + id, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  publishToreadingList(
    existingCollectionId,
    operation,
    resourceIds,
    name,
    description,
    imageUrl,
    locationId,
    auth
  ) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
      "Content-Type": "application/json",
    });
    return this.http
      .post(
        this.apiUrl + "resource/readinglist/publishtoreadinglist",
        {
          existingCollectionId: existingCollectionId,
          operation: operation,
          resourceIds: resourceIds,
          name: name,
          description: description,
          imageUrl: imageUrl,
          locationId: locationId,
        },
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  publishToNewInLibrary(
    existingCollectionId,
    operation,
    resourceIds,
    name,
    auth
  ) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
      "Content-Type": "application/json",
    });
    return this.http
      .post(
        this.apiUrl + "resource/readinglist/publishtoreadinglist",
        {
          existingCollectionId: existingCollectionId,
          operation: operation,
          resourceIds: resourceIds,
          name: name,
        },
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  publishToNewList(resourceIds, name, description, imageUrl, locationId, auth) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
      "Content-Type": "application/json",
    });
    return this.http
      .post(
        this.apiUrl + "resource/readinglist/publishtonew",
        {
          name: name,
          description: description,
          imageUrl: imageUrl,
          locationId: locationId,
          resourceIds: resourceIds,
        },
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  isReviewedByPatron(auth, id) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      "app-id": "opac",
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth,
    });
    return this.http
      .get(this.apiUrl + "review/isreviewedbycurrentpatron/" + id, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getAccountDetail(auth, sortBy, order) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      "app-id": "opac",
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth,
    });
    return this.http
      .get(
        this.apiUrl + "account/status?sortBy=" + sortBy + "&order=" + order,
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getAccountHistory(auth, listSize, offSet, sortBy, order) {
    var string = "";
    if (offSet != 0) {
      string =
        "?offset=" +
        offSet +
        "&size=" +
        listSize +
        "&sortBy=" +
        sortBy +
        "&order=" +
        order;
    }
    if (offSet == 0) {
      string = "?&sortBy=" + sortBy + "&order=" + order;
    }

    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      "app-id": "opac",
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth,
    });
    return this.http
      .get(this.apiUrl + "account/history" + string, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getSortHistory(auth, sortBy, listSize, offSet) {
    var string = "";
    string = "?offset=" + offSet + "&size=" + listSize + "&sortBy=" + sortBy;

    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      "app-id": "opac",
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth,
    });

    return this.http
      .get(this.apiUrl + "account/history" + string, { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  publishReview(reviewId, auth) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
      "Content-Type": "application/json",
    });
    return this.http
      .post(
        this.apiUrl + "review/edit/publishstatus/" + reviewId,
        {},
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  addStarRating(resourceId, starRating, patronId = null, auth) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth,
    });
    return this.http
      .post(
        this.apiUrl + "review/rating/add",
        { patronId: patronId, resourceId: resourceId, star: starRating },
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  titleRenew(sessionId, cirOutId, auth) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth,
    });
    return this.http
      .post(
        this.apiUrl + "account/renew",
        {
          sessionId: sessionId,
          circOutId: cirOutId,
        },
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  cancelHoldAccount(circHoldId, auth) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth,
    });
    return this.http
      .post(
        this.apiUrl + "account/holdcancel",
        {
          circHoldId: circHoldId,
        },
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  holdResource(sessionId, resourceId, desiredDate, auth) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth,
    });
    return this.http
      .post(
        this.apiUrl + "account/hold",
        {
          sessionId: sessionId,
          resourceId: resourceId,
          desired: desiredDate,
        },
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  reOrderExploreButtons(wid, newIndex, auth, pageId) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth,
    });
    return this.http
      .get(
        this.apiUrl +
          "explore/button/move?id=" +
          wid +
          "&position=" +
          newIndex +
          "&pageId=" +
          pageId,
          { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  exploreButtonsPublish(wid, status, auth) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth,
    });
    return this.http
      .get(this.apiUrl + "explore/button/hide?id=" + wid + "&hide=" + status,  { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  exploreButtonsDelete(wid, auth) {
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth,
    });
    return this.http
      .delete(this.apiUrl + "explore/button/delete?id=" + wid,  { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  printFormat(cacheKey, facets, type) {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .get(
        this.apiUrl +
          "resource/list/bibliography?cacheKey=" +
          cacheKey +
          "&type=" +
          type +
          "&facets=" +
          facets,
          { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getExploreImage() {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .get(this.apiUrl + "explore/button/images/style",  { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getExploreCustomImage() {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .get(this.apiUrl + "explore/button/images",  { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getExplorePages() {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http.get(this.apiUrl + "explore/pagelist",  { headers: headers, observe:'response' }).pipe(
      map((response: HttpResponse<any>) => {
        if(response.headers.get('Session-Id')){
         this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
        return response.body;
      }),
      catchError((error) => this.handleError(error))
    );
  }

  saveExploreButton(
    buttonId,
    pageId,
    title,
    visible,
    actionType,
    target,
    image,
    pageName
  ) {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    var reqData = {
      id: buttonId,
      opacExplorePageId: pageId,
      caption: title,
      visible: visible,
      action: actionType,
      target: target,
      image: image,
    };
    //console.log(actionType, target, "these are target");
    if (actionType == "V" && target == "0") {
      reqData["pageName"] = pageName;
      //log(actionType, target, pageName, "these are target for");
    }
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: "Bearer " + auth,
    });
    return this.http
      .post(this.apiUrl + "explore/button/save", reqData,  { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getExploreButtonStyle() {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .post(this.apiUrl + "explore/page/getgraphicstyle", [],  { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  updateButtonsStyles(style) {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "application/json",
      Authorization: auth,
    });
    return this.http
      .post(
        this.apiUrl + "explore/page/changegraphicstyle?value=" + style,
        [],
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getResourcesList(params?: any): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
      //,'Authorization': auth
    }
    this.tenantLocId = this.cookieService.get("selectedlocation" + this.tetent);
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    let paramsData = params;
    return this.http.get(this.apiUrl + "resource/list",  {params:paramsData, headers: headers, observe:'response' }).pipe(
      map((response: HttpResponse<any>) => {
      if(response.headers.get('Session-Id')){
         this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
        return response.body;
      }),
      catchError((error) => this.handleError(error))
    );
  }

  /* CSV file download */
  getCSV(cache, facets): any {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "Content-Type": "application/octet-stream",
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(
        this.apiUrl +
          "resource/list/csv?cacheKey=" +
          cache +
          "&facets=" +
          facets,
        { headers, responseType: "blob" }
      )
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  /* Marc file download */
  getMarc(cache, facets): any {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    let headers = new HttpHeaders({
      "Content-Type": "application/octet-stream",
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .get(
        this.apiUrl +
          "resource/list/marc?cacheKey=" +
          cache +
          "&facets=" +
          facets,
        { headers, responseType: "blob" }
      )
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  getEmail(cache, facets, type): Observable<any> {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    this.tenantLocId = this.cookieService.get("selectedlocation" + this.tetent);
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
      "Content-Type": "application/json",
    });
    return this.http
      .post(
        this.apiUrl +
          "resource/list/email?cacheKey=" +
          cache +
          "&facets=" +
          facets +
          "&type=" +
          type,
        {},
        { headers: headers, observe:'response' }
      )
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  updateTheme(auth, themeName) {
    let headers = new HttpHeaders({
      "app-id": "opac",
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth,
    });

    return this.http
      .post(this.apiUrl + "setting/theme", { theme: themeName },  { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  //currency format
  formatCurrency(cost) {
    var formatter;
    var formattedCost;
    var currency = this.globalRegionalSetting.data.currency;
    switch (currency) {
      case "$":
        formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        });
        cost = formatter.format(cost);
        break;
      case "€€":
        formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "EUR",
        });
        cost = formatter.format(cost);
        break;
      case "£":
        formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "GBP",
        });
        cost = formatter.format(cost);
        break;
      case "€":
        formatter = new Intl.NumberFormat("it-US", {
          style: "currency",
          currency: "EUR",
        });
        cost = formatter.format(cost);
        break;
      case "₹":
        formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "INR",
        });
        cost = formatter.format(cost);
        break;
      default:
        formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        });
        cost = formatter.format(cost);
        break;
    }
    return cost;
  }

  formatDate() {
    if (!this.globalRegionalSetting) {
      return "M/d/yyyy";
    }
    var dateFormatGet = this.globalRegionalSetting.data.date;
    var dateFormat = "M/d/yyyy";
    switch (dateFormatGet) {
      case "M/d/yyyy":
        dateFormat = "M/d/yyyy";
        break;
      case "MM/dd/yyyy":
        dateFormat = "MM/dd/yyyy";
        break;
      case "MM-dd-yyyy":
        dateFormat = "MM-dd-yyyy";
        break;
      case "dd/MM/yyyy":
        dateFormat = "dd/MM/yyyy";
        break;
      case "dd-MM-yyyy":
        dateFormat = "dd-MM-yyyy";
        break;
      case "yyyy/MM/dd":
        dateFormat = "yyyy/MM/dd";
        break;
      case "yyyy-MM-dd":
        dateFormat = "yyyy-MM-dd";
        break;
      case "MM/dd/yy":
        dateFormat = "MM/dd/yy";
        break;
      case "yy/MM/dd":
        dateFormat = "yy/MM/dd";
        break;
      case "dd-MMM-yy":
        dateFormat = "dd-MMM-yy";
        break;
      case "dddd, MMMM d, yyyy":
        dateFormat = "EEEE, MMMM d, yyyy";
        break;
      case "MMMM d, yyyy":
        dateFormat = "MMMM d, yyyy";
        break;
      case "dddd, d MMMM, yyyy":
        dateFormat = "EEEE, d MMMM, yyyy";
        break;
      case "d MMMM, yyyy":
        dateFormat = "d MMMM, yyyy";
        break;
      default:
        dateFormat = "MM/dd/yyyy";
        break;
    }
    return dateFormat;
  }

  formatDateTime() {
    var date = this.formatDate();
    var timeFormatGet = this.globalRegionalSetting.data.time;
    var timeformat = "h:mm a";
    switch (timeFormatGet) {
      case "h:mm tt":
        timeformat = "h:mm a";
        break;
      case "hh:mm tt":
        timeformat = "hh:mm a";
        break;
      case "H:mm":
        timeformat = "H:mm";
        break;
      case "HH:mm":
        timeformat = "HH:mm";
        break;
      case "hh:mm:ss tt":
        timeformat = "hh:mm:ss a";
        break;
      case "HH:mm:ss":
        timeformat = "HH:mm:ss";
        break;
    }
    return date + " " + timeformat;
  }

  bgColor(patronId) {
    var colors = [
      "bg-gray-dark",
      "bg-primary",
      "bg-info",
      "bg-success",
      "bg-mint",
      "bg-warning",
      "bg-danger",
      "bg-purple",
      "bg-pink",
      "bg-dark",
    ];
    var number = patronId;
    var lastDigit = number.toString().slice(-1);
    return colors[lastDigit];
  }

  initialName(name) {
    var result = "";
    var tokens = name.split(/\s/);
    for (var i = 0; i < tokens.length; i++) {
      result += tokens[i].substring(0, 1).toUpperCase();
    }
    return result;
  }
  getGlobalRegionalSetting() {
    return this.globalRegionalSetting;
  }
  getAuthorization(authToke): Observable<any> {
    // var authTok:any = 'null';
    // //if(this.cookieService.check( 'info')){
    //if (localStorage.getItem('info') != null){
    //    var authTok:any =  'Bearer '+localStorage.getItem('token');
    // }
    var authTok = authToke;
    return authTok;
  }

  //  /* call the api to sorted data from History pages*/

  //   getSortHistory(auth, sortBy, listSize, offSet){
  //     var string = ''
  //     string = '?offset='+offSet+'&size='+listSize+'&sortBy='+sortBy;

  //     let headers = new HttpHeaders({'selectedlibrary': this.tenantLocId,'app-id' : 'opac','tenant': this.tetent,  'configuration' : this.confiGurationSetting,'Content-Type': 'application/json', 'Authorization' : 'Bearer '+auth});

  //     return this.http.get(this.apiUrl+'account/history'+string,{headers}).pipe(
  //       map((response: HttpResponse<any>) => {
  //         return response;
  //         }
  //     ));
  //   }

  getAccountSort(auth, sortBy, offSet) {
    var string = "";
    string = "?offset=" + offSet + "&sortBy=" + sortBy;

    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      "app-id": "opac",
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth,
    });
    return this.http
      .get(this.apiUrl + "account/status" + string,  { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }
  exploreDescription(pageId, description) {
    var auth: any = "null";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info") != null) {
      var auth: any = "Bearer " + localStorage.getItem("token");
    }
    var reqData = {
      id: pageId,
      description: description,
    };
    let headers = new HttpHeaders({
      selectedlibrary: this.tenantLocId,
      tenant: this.tetent,
      configuration: this.confiGurationSetting,
      Authorization: auth,
    });
    return this.http
      .post(this.apiUrl + "explore/page/description/add ", reqData,  { headers: headers, observe:'response' })
      .pipe(
        map((response: HttpResponse<any>) => {
          if(response.headers.get('Session-Id')){
            this.authService.setSessionIdHeader(response.headers.get('Session-Id'));
      }
 this.authService.setIdleTimer();
          return response.body;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  public handleError(error: any) {
    if (error.status == 401) {
        this.authService.logoutSubject.next(true);
      return EMPTY;
    } else {
      return throwError(error);
    }
  }
}
